import {useMutation} from '@tanstack/react-query';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import campaignUpdaters from '@/api/updaters/campaign';

export interface SubmitCampaignCloseFeedbackVariables {
  campaignId: string;
  rating: number;
  comment?: string | null;
}

interface UseSubmitCampaignCloseFeedbackOptions {
  onSuccess?: () => void;
  onError?: () => void;
}

function useSubmitCampaignCloseFeedback({
  onSuccess,
  onError,
}: UseSubmitCampaignCloseFeedbackOptions = {}) {
  return useMutation({
    mutationFn: (variables: SubmitCampaignCloseFeedbackVariables) =>
      campaignUpdaters.submitCloseFeedback(variables),

    onSuccess: () => {
      raiseFlashMessage({
        status: 'success',
        message: translate('Thanks for your feedback!'),
      });
      onSuccess?.();
    },

    onError: () => {
      raiseFlashMessage({
        status: 'error',
        message: translate('Failed to submit feedback. Please try again.'),
      });
      onError?.();
    },
  });
}

export default useSubmitCampaignCloseFeedback;
